module.exports = __webpack_public_path__ + "static/media/fire-extinguisher.58dbde0e.svg";